import ChatBlock from "../components/ChatBlock";
import ServicesRow from "../components/ServicesRow";

function determineResponseType(response: any): "emergency" | "out_of_scope" | "no_services" | "services_found" {
  if (response.is_emergency) return "emergency";
  if (response.is_out_of_scope) return "out_of_scope";
  if (response.no_services_found) return "no_services";
  return "services_found";
}

function getSessionBlocks(response: any, responseType: string, t: any) {
  const blocks = [];
  
  switch (responseType) {
    case "emergency":
      blocks.push({
        type: "chat",
        data: {
          text: t("RecoSearch.emergency"),
          engineResponse: true
        }
      });
      break;

    case "out_of_scope":
      blocks.push({
        type: "chat",
        data: {
          text: t("RecoSearch.out_of_scope"),
          engineResponse: true
        }
      });
      break;
      
    case "no_services":
      blocks.push({
        type: "chat",
        data: {
          text: t("RecoSearch.no_services_found"),
          engineResponse: true
        }
      });
      blocks.push({
        type: "chat",
        data: {
          text: t("RecoSearch.additional_info"),
          engineResponse: true
        }
      });
      break;
      
    case "services_found":
      blocks.push({
        type: "chat",
        data: {
          text: response?.message,
          engineResponse: true
        }
      });
      blocks.push({
        type: "services",
        data: {
          services: response.services
        }
      });
      break;
      
    default:
      // Handle unexpected response types
      blocks.push({
        type: "chat",
        data: {
          text: t("RecoSearch.error_occurred") || "An error occurred",
          engineResponse: true
        }
      });
      break;
  }
  
  return blocks;
}

function getUIBlocks(response: any, responseType: string, t: any) {
  const blocks = [];
  const timestamp = Date.now();
  const randomId = Math.random().toString(36).substr(2, 9);
  
  switch (responseType) {
    case "emergency":
      blocks.push(
        <ChatBlock 
          key={`chat-${timestamp}-${randomId}`} 
          text={t("RecoSearch.emergency")} 
          engineResponse 
        />
      );
      break;

    case "out_of_scope":
      blocks.push(
        <ChatBlock 
          key={`chat-${timestamp}-${randomId}`} 
          text={t("RecoSearch.out_of_scope")} 
          engineResponse 
        />
      );
      break;
      
    case "no_services":
      blocks.push(
        <ChatBlock 
          key={`chat-${timestamp}-${randomId}`} 
          text={t("RecoSearch.no_services_found")} 
          engineResponse 
        />
      );
      blocks.push(
        <ChatBlock 
          key={`chat-${timestamp}-${randomId}`} 
          text={t("RecoSearch.additional_info")} 
          engineResponse 
        />
      );
      break;
      
    case "services_found":
      blocks.push(
        <ChatBlock 
          key={`chat-${timestamp}-${randomId}-1`} 
          text={response?.message} 
          engineResponse 
        />
      );
      blocks.push(
        <ServicesRow 
          key={`services-${timestamp}-${randomId}-2`} 
          services={response.services} 
        />
      );
      break;
      
    default:
      // Handle unexpected response types
      blocks.push(
        <ChatBlock 
          key={`chat-${timestamp}-${randomId}`} 
          text={t("RecoSearch.error_occurred") || "An error occurred"} 
          engineResponse 
        />
      );
      break;
  }
  
  return blocks;
}

const handleRenderedBlocks = (response: any, t: any) => {
  // Determine what type of response we have and what should be rendered
  const responseType = determineResponseType(response);
  
  // Debug logging
  console.log("Response type:", responseType);
  console.log("Response:", response);
  
  // Return structured data for both session management and UI rendering
  return {
    responseType,
    sessionBlocks: getSessionBlocks(response, responseType, t),
    uiBlocks: getUIBlocks(response, responseType, t),
  };
};

export default handleRenderedBlocks;
